// extracted by mini-css-extract-plugin
export default {"dropOverContainer":"f8ZmKwQola","dropOverContainer_visible":"_CzYrRiVbo","responsiveContainer":"b9h_N1WoJB","content":"uppMURTqSU","header":"kxdRpD3T10","title":"fSJY3o5n8W"};